import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createUseStyles} from 'react-jss';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import CheckoutOverlay from '../CheckoutOverlay';

const useStyles = createUseStyles({
  contactNumberOverlay: {
    fontSize: 16,
  },
  buttonContainer: {
    marginTop: '1em',
  },
});

export function ContactNumberOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      className={classes.contactNumberOverlay}
      data-test="ContactNumberOverlay"
      title="checkout.delivery.address.field.contact.number.hint.link"
    >
      <Translation>checkout.delivery.address.field.contact.number.info.text</Translation>
      <div
        className={classes.buttonContainer}
        data-test="ContactNumberOverlay__buttonContainer"
      >
        <Button
          id="ContactNumberOverlay__closeButton"
          className="ContactNumberOverlay__closeButton"
          primary
          fullWidth
          onClick={props.hideOverlay}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

ContactNumberOverlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
};

export default connect(
  null,
  {hideOverlay},
)(ContactNumberOverlay);
